/**
 * Logique pure de l'onglet Gestion opérationnelle (#890) : filtres de l'API et statut prévu des
 * tournées en vigueur. Sans JSX ni React Query, testée par `operations-list.test.mjs`.
 */

import type {
  ActiveTourItem,
  ActiveToursQuery,
  OperationalTourStatus,
} from '~/lib/logistics-operations-query'
import type { LogisticsSearch } from '~/routes/_authenticated/logistics/-search-schema'
import { mapStatusFilterOf } from './simulator-list'

/**
 * Paramètres de `GET /logistics/operations/tours` pour les filtres de l'URL : ceux du simulateur,
 * sans la Période, que l'API ignore en V1.
 */
export const activeToursQueryOf = (filters: Omit<LogisticsSearch, 'tab'>): ActiveToursQuery => ({
  centralKitchenId: filters.kitchen,
  departmentCode: filters.department,
  q: filters.q,
})

/** Statut prévu, déduit de l'horaire (pas encore de suivi réel), dans l'ordre de la liste. */
export const OPERATIONAL_TOUR_STATUS_LABELS: Record<OperationalTourStatus, string> = {
  in_progress: 'En cours',
  planned: 'Planifiée',
}

/** Carte de l'onglet : filtre sur le statut prévu de la tournée, pas sur celui de sa simulation. */
export const OPERATIONS_MAP_STATUS_FILTER = mapStatusFilterOf<
  ActiveTourItem,
  OperationalTourStatus
>(OPERATIONAL_TOUR_STATUS_LABELS, (item) => item.tour.status)
